import { render, staticRenderFns } from "./asterisk.vue?vue&type=template&id=3d9a1878&"
var script = {}
import style0 from "./asterisk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports